import OrderQuantityBreakdownByPropertyACQueries from './OrderQuantityBreakdownByPropertyACQueries'

const mvOqbbpa = {
  mvOqbbpa: {
    ...OrderQuantityBreakdownByPropertyACQueries,
  }
}

export default mvOqbbpa